import { CatalogFormField, CatalogFormSchema } from '../services/serviceCatalogApi';
import { CatalogFormFieldDraft } from '../types/CatalogFormFieldDraft';

export function toCatalogFormFieldDrafts(fields: CatalogFormField[]): CatalogFormFieldDraft[] {
  return fields.map((field) => ({
    ...field,
    id: crypto.randomUUID(),
  }));
}

export function serializeCatalogFormSchema(fields: CatalogFormFieldDraft[]): string {
  const meaningful = fields.filter((field) => field.name.trim() || field.label.trim());
  if (meaningful.length === 0) {
    return '';
  }

  return JSON.stringify({
    fields: meaningful.map(({ id: _id, ...field }) => ({
      name: field.name.trim(),
      label: field.label.trim() || field.name.trim(),
      type: field.type,
      ...(field.required ? { required: true } : {}),
      ...(field.type === 'select' && field.options?.length
        ? { options: field.options.filter(Boolean) }
        : {}),
    })),
  } satisfies CatalogFormSchema);
}
